module.exports = __webpack_public_path__ + "static/media/buzon-rojo-seguimiento.924fd8e7.png";